import React from "react";
import Constant from "../../../utils/constant";

export interface OnSentryCatchParam {
	request: string;
	error: string;
}

export interface LayoutProps {
	isDev: boolean;
	isUat: boolean;
	cookies: { [key: string]: string };
	runtime: {
		languageCode: string;
		countryCode: string;
		currency: string;
		sid: string;
		platform: string;
		countryCode2?: string;
		countryId?: string;
	};
	onChangeLanguage?: (lan?: string) => void;
	onSentryCatch?: (props: OnSentryCatchParam) => void;
}

export interface LayoutWithConstantProps extends LayoutProps {
	children?: any;
}

export function headerConstant<P extends LayoutWithConstantProps>(WrapperComponent) {

    class WithTransPageComponent extends React.Component<P> {

		render() {
            const { isUat, isDev, cookies, runtime } = this.props;
            Constant.isDev = !!isDev;
            Constant.isUat = isUat ? true : false;
            Constant.sessionKey = cookies["sessionKey"] || "";
            Constant.isLogin = !!cookies["sessionKey"];

            Constant.sid = runtime?.sid || "0";
            Constant.country = runtime?.countryCode || "USA";
            Constant.countryCode2 = runtime?.countryCode2 || "US";
            Constant.language = runtime?.languageCode || "en";
            Constant.currency = runtime?.currency || "USD";
            Constant.platform = runtime?.platform;
            Constant.countryId = runtime?.countryId || "223";
			return (
				<WrapperComponent {...this.props} />	
			);
		}
	}

    return WithTransPageComponent
}